import { render, staticRenderFns } from "./Requerimiento.vue?vue&type=template&id=42b663dc"
import script from "./Requerimiento.vue?vue&type=script&lang=js"
export * from "./Requerimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports